import { RouterProvider } from 'react-router-dom'

import { Notifications } from '@/components/Notifications'
import { router } from '@/routes/router.tsx'
import { useStoreDispatch } from '@/store/hooks'

export function App() {
  const dispatch = useStoreDispatch()
  return (
    <>
      <RouterProvider router={router(dispatch)} />
      <Notifications />
    </>
  )
}
